import React from "react";

import { cn } from "../../lib/utils";

export default function StaticInfoBanner({ text, className }) {
  if (!text) return null;

  return (
    <div
      className={cn(
        "flex h-12 w-full max-w-[var(--max-width)] items-center justify-center bg-[var(--theme-action-fill)] px-5 py-4 text-center font-montserrat text-xs font-normal text-[var(--theme-action-text)]",
        className,
      )}
    >
      {text}
    </div>
  );
}
